const QUERYGEN_EMAIL_DOMAIN = "querygen.ai";
const SLUG_REPLACE_REGEX = /[^a-z0-9]+/g;
const SLUG_TRIM_REGEX = /^-|-$/g;

export function isQuerygenEmail(email: string): boolean {
  const normalizedEmail = email.trim().toLowerCase();
  const separatorIndex = normalizedEmail.lastIndexOf("@");

  return (
    separatorIndex > 0 &&
    normalizedEmail.slice(separatorIndex + 1) === QUERYGEN_EMAIL_DOMAIN
  );
}

export function canCreateOrganization(
  email: string,
  hasOrganizationMembership: boolean,
): boolean {
  return !hasOrganizationMembership || isQuerygenEmail(email);
}

export function generateOrganizationSlug(name: string): string {
  const trimmedName = name.trim();
  const asciiSlug = trimmedName
    .toLowerCase()
    .replace(SLUG_REPLACE_REGEX, "-")
    .replace(SLUG_TRIM_REGEX, "");

  if (asciiSlug) return asciiSlug;

  const codePointSlug = Array.from(trimmedName, (character) =>
    character.codePointAt(0)!.toString(36),
  ).join("-");

  return `org-${codePointSlug}`;
}
